import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/inputs/get-locations-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchLocationListContext } from '../../location.context';
import { LocationListFilterSearchFormStep1Controller } from '../location-list-filter-search-form-step-1/location-list-filter-search-form-step-1.controller';

export interface LocationListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetLocationsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetLocationsPaginatedModel>;
  onCancel: () => void;
}

export const LocationListFilterSearchFormController = (
  props: LocationListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchLocationListContext();

  return (
    <HeadlessFormProvider<GetLocationsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <LocationListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
